import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FormControl, FormGroup } from '@angular/forms';
import { IEmployee, IEmployeePaginatedResponseApi, IEmployeeSingleResponseApi } from 'src/app/interfaces/employee/employee.interface';

@Injectable({
  providedIn: 'root'
})

export class EmployeeService {
  private readonly http = inject(HttpClient);

  formFilterList = new FormGroup({
    document: new FormControl(''),
    name: new FormControl(''),
    email: new FormControl(''),
    status: new FormControl(''),
    page: new FormControl(1),
    pageSize: new FormControl(5),
    sortBy: new FormControl(''),
    sortOrder: new FormControl(''),
  });

  listAll(payload: {
    document?: string;
    name?: string;
    email?: string;
    status?: string;
    pageSize: number;
    page: number;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams()
      .set('page', payload.page)
      .set('pageSize', payload.pageSize)

    if (payload.document) {
      params = params.set('document', payload.document);
    }

    if (payload.name) {
      params = params.set('name', payload.name);
    }

    if (payload.email) {
      params = params.set('email', payload.email);
    }

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get<IEmployeePaginatedResponseApi>(
      `${environment.api}/employee/all`, { params }
    );
  }

  getById(id: string) {
    return this.http.get<IEmployeeSingleResponseApi>(
      `${environment.api}/employee/${id}`
    );
  }

  export(payload: {
    document?: string;
    name?: string;
    email?: string;
    status?: string;
    sortBy?: string;
    sortOrder?: string;
  }) {
    let params = new HttpParams();

    if (payload.document) {
      params = params.set('document', payload.document);
    }

    if (payload.name) {
      params = params.set('name', payload.name);
    }

    if (payload.email) {
      params = params.set('email', payload.email);
    }

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.sortBy) {
      params = params.set('sortBy', payload.sortBy);
    }

    if (payload.sortOrder) {
      params = params.set('sortOrder', payload.sortOrder);
    }

    return this.http.get(
      `${environment.api}/employee/all/export`,
      { params, responseType: 'blob' }
    );
  }

  register(body: IEmployee) {
    if (body.id) {
      return this.update(body);
    }
    else {
      return this.create(body);
    }
  }

  create(body: IEmployee) {
    return this.http.post<IEmployee>(
      `${environment.api}/employee/create`, body
    );
  }

  update(body: IEmployee) {
    return this.http.put<IEmployee>(
      `${environment.api}/employee/update/${body.id}`, body
    );
  }
}
